import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { LOCALE_ID } from '@angular/core';

// Note(Moris): RxJS � una libreria piuttosto grande, le buone prassi indicano di importare solamente gli operatori indispensabili
import "rxjs/Rx";
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/catch';


import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { ConfigPage } from '../pages/config/config';
import { PropertiesPage } from '../pages/properties/properties';
import { ResidentialPage } from '../pages/residential/residential';
import { GalleryPage } from '../pages/gallery/gallery';

import { PropertiesPopover } from '../components/popovers/properties.popover';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { ZCurrencyPipe } from '../pipes/zcurrency';

import { AuthHttp } from '../services/auth.http';
import { AuthService } from '../services/auth.service';
import { PropertiesService } from '../services/properties.service';
import { ResidentialService } from '../services/residential.service';
import { ImagesService } from '../services/images.service';

import { ConfigStore } from '../stores/config.store';
import { UserStore } from '../stores/user.store';
import { PropertiesStore } from '../stores/properties.store';
import { ResidentialStore } from '../stores/residential.store';

@NgModule({
    declarations: [
        MyApp,
        ZCurrencyPipe,
        HomePage,
        LoginPage,
        ConfigPage,
        PropertiesPage,
        ResidentialPage,
        GalleryPage,
        PropertiesPopover
    ],
    imports: [
        HttpModule,
        BrowserModule,
        IonicModule.forRoot(MyApp),
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        HomePage,
        LoginPage,
        ConfigPage,
        PropertiesPage,
        ResidentialPage,
        GalleryPage,
        PropertiesPopover
    ],
    providers: [
        StatusBar,
        SplashScreen,
        AuthHttp,
        AuthService,
        PropertiesService,
        ResidentialService,
        ImagesService,
        ConfigStore,
        UserStore,
        PropertiesStore,
        ResidentialStore,
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        { provide: LOCALE_ID, useValue: "it-IT" }
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts